<div #resizeContainer class="resize-container" fxLayout>
    <div class="left-pane">
        <ng-content #leftPane select="[leftContent]"></ng-content>
    </div>
    @if (showPane().both) {
        <div class="resize-bar m-x" (mousedown)="startResizing()">
            <mat-icon class="material-symbols-outlined">arrows_outward</mat-icon>
        </div>
    }
    <div class="right-pane">
        <ng-content select="[rightContent]"></ng-content>
    </div>
</div>
